import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null=checking, false=guest

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) return;
    refresh();
  }, [refresh]);

  const signIn = useCallback((data) => setUser(data.user), []);

  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch { /* local sign-out still proceeds */ }
    setUser(false);
  }, []);

  const value = useMemo(() => ({ user, setUser, refresh, signIn, logout }), [user, refresh, signIn, logout]);
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
